import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "text-dark fw-bolder fs-3 mb-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle ms-2 text-primary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync-alt" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-muted fw-bold fs-7" }
const _hoisted_9 = { class: "card-body pt-5" }
const _hoisted_10 = { class: "timeline-label" }
const _hoisted_11 = { class: "timeline-badge" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "ms-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-light bg-light" }, "###")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless fs-1" })
], -1)
const _hoisted_20 = { class: "timeline-content text-muted ps-3" }
const _hoisted_21 = { class: "text-light bg-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.widgets.recentOrders.title")) + " ", 1),
          (_ctx.ordersData && _ctx.ordersData.branch)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " [" + _toDisplayString(_ctx.ordersData.branch.name.replace("Sushi Eden - ", "")) + "] ", 1))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
                type: "button",
                class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
              }, _hoisted_7))
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ordersData && _ctx.ordersData.totalOrders
              ? _ctx.I18nUtils.translate("sea.widgets.recentOrders.orders", {
                  count: _ctx.ordersData.totalOrders,
                })
              : _ctx.I18nUtils.translate("sea.widgets.recentOrders.totalOrders")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_ctx.ordersData && _ctx.ordersData.orders)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.ordersData.orders, (order) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "timeline-item",
                key: order.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["timeline-label fw-bolder fs-6", { 'text-muted': !_ctx.DateTimeUtils.isToday(order.createdAt) }])
                }, _toDisplayString(_ctx.DateTimeUtils.parseHourAndMinute(order.createdAt)), 3),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa fa-genderless fs-1", [_ctx.getOrderColor(order)]])
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["timeline-content ps-3", {
                'fw-bolder': _ctx.DateTimeUtils.isToday(order.createdAt),
                'text-muted': !_ctx.DateTimeUtils.isToday(order.createdAt),
              }])
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'order', params: { id: order.id } },
                    class: "text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(order.orderNumber), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (order.paymentMethod === 1)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fa fa-fw fa-money ms-2",
                        title: 
                  _ctx.I18nUtils.translate(
                    'sea.widgets.recentOrders.paymentMethodCash'
                  )
                
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (order.paymentMethod === 2)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "fa fa-fw fa-credit-card ms-2",
                        title: 
                  _ctx.I18nUtils.translate(
                    'sea.widgets.recentOrders.paymentMethodEftpos'
                  )
                
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (order.paymentMethod === 3)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 2,
                        class: "fa fa-fw fa-globe ms-2",
                        title: 
                  _ctx.I18nUtils.translate(
                    'sea.widgets.recentOrders.paymentMethodOnline'
                  )
                
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (order.type === 1)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 3,
                        class: "fa fa-fw fa-shopping-bag ms-2",
                        title: _ctx.I18nUtils.translate('sea.widgets.recentOrders.pickUp')
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (order.type === 2)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 4,
                        class: "fa fa-fw fa-shipping-fast ms-2",
                        title: 
                  _ctx.I18nUtils.translate('sea.widgets.recentOrders.delivery')
                
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.I18nUtils.translate(
                    "sea.widgets.recentOrders.orderDescription",
                    { name: order.name, type: _ctx.getOrderType(order.type) }
                  )), 1)
                ], 2)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(10, (index) => {
              return _createElementVNode("div", {
                class: "timeline-item",
                key: index
              }, [
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString("#".repeat(_ctx.NumberUtils.getRandomNumber(10, 30))), 1)
                ])
              ])
            }), 64))
      ])
    ])
  ], 2))
}